<template>
  <v-container fluid fill-height class="full-height">
    <v-layout align-center justify-center>
      <div class="mr-3 hidden-sm-and-down">
        <img src="/static/error/403.svg" alt="" />
      </div>
      <div class="text-md-center">
        <h1>Single Sign On</h1>
        <h1 class="my-3 headline">인증 중....</h1>
      </div>
    </v-layout>
  </v-container>
</template>

<script>
import pkg from '../../package';
import { mapState } from 'vuex';
import menu from '@/api/menu';
import moment from 'moment';
import Util from '@/util';
export default {
  data: () => ({
    title: pkg.title,
    mode: {
      login: true,
    },
  }),
  computed: {
    ...mapState(['isUserLoggedIn']),
  },
  async mounted() {
    console.log('mounted');
    let code = Util.getParam('code');
    let state = Util.getParam('state');
    this.$http.get('/api/auth/userIp').then((response) => {
      let userIp = response.data;
      this.ssoLoginResult(code, state, userIp);
    });
    return;
    if (this.$route.query) {
      console.log('===this.$route.query===');
      console.log(this.$route.query.user);
      // PARAM_CODE, PARAM_STATE 받기

      // getTokenByCode ( codr 값으로, token 값 받기.)

      // getUserInfo ( token 값으로 userInfo 받기 )

      // userId 값으로 로그인 처리.

      await this.ssoLoginSuccess(
        decodeURI(this.$route.query.user),
        decodeURI(this.$route.query.loginToken)
      );
      // await this.loginSuccess(JSON.parse(decodeURI(this.$route.query.user)));
    } else if (this.$route.params) {
      console.log('===this.$route.params.user===');
      console.log(this.$route.params.user);
      await this.ssoLoginSuccess(
        decodeURI(this.$route.query.user),
        decodeURI(this.$route.query.loginToken)
      );
      // await this.loginSuccess(JSON.parse(decodeURI(this.$route.params.user)));
    }
  },
  methods: {
    ssoLoginResult(authCode, state, userIp) {
      let getTokenResult = this.getTokenByCode(authCode, userIp);
    },
    async getTokenByCode(code, userIp) {
      let ssoStatus = (await this.$http.get('/api/auth/sso/status')).data.ssoStatus;
      let result = {};
      if (ssoStatus === 'production') {
        result = { sso_url: 'https://sso.ksd.or.kr:8443', client_id: 'DWS', client_secret: 'YDuE_T6f-IKBrBGvg5CBaE3X0MN4xKOnorj5b2XmvgQF7gS3KKQTWhXm7L47ERcqdW8BODh_E10PGTEm8KIigw' };
      } else if (ssoStatus === 'prev_production') {
        result = { sso_url: 'https://didc-sso.ksd.or.kr:8443', client_id: 'DWS', client_secret: 'eMw8rZvJS5xpvC6g8EZBhPwIXtyNLGhe_NGut0Hl_nbk0BeSZ3_r0EXJukOsLfEukIpEV9E5jj97LVg4QZbKqw' };
      } else {
        // 개발
        result = { sso_url: 'https://ssodev.ksd.or.kr:4443', client_id: 'Conf', client_secret: 'suJzdda7yrvq3zcOqwRAE__BNdZA3do_cOmyOvhMYwojSMi9DbOH9klnJ91YdtuGKmdPYyZyXJP5DCPtSfR2sA' };
      }
      
      const client_id = result.client_id;
      const client_secret = result.client_secret;
      let parameters = '';

      parameters += 'response_type' + '=' + 'id_token' + '&';
      parameters += 'code' + '=' + code + '&';
      parameters += 'client_id' + '=' + client_id + '&';
      parameters += 'client_secret' + '=' + client_secret + '&';
      parameters += 'iscltapi' + '=' + 'Y' + '&';
      parameters += 'w_user_inf' + '=' + 'Y' + '&';
      parameters += 'remote_ip' + '=' + userIp + '&';
      parameters += 'tgentme' + '=' + this.getUnixTime();

      this.$http
        .post('/api/auth/checkSso', parameters)
        .then(async (response) => {
          this.$store.dispatch('setToken', response.data.token);
          this.$store.dispatch('setUser', response.data.user);

          this.$cookies.set('token', response.data.token, 43200000);
          this.$http.defaults.headers.common['Authorization'] =
            'Bearer ' + response.data.token;

          this.$http
            .post('/api/auth/login/log')
            .then((response) => {
              console.log(response.data);
            })
            .catch((error) => {
              console.log(error);
              // this.error = error.response.data.error;
            });

          const isAdmin = (await this.$http.get('/api/auth/check/admin/server'))
            .data;
          setTimeout(() => {
            if (isAdmin === true) {
              this.$router.replace('/dashboard');
            } else {
              this.$router.replace('/sMeeting');
            }
            this.loading = false;
          }, 500);

          // setTimeout(() => {
          //   this.$router.replace('/kMeeting');
          //   this.loading = false;
          // }, 500);
        });
      // let result = post(sso_url+consts.
      //   , parameters);
      // return JSON.parse(parameters);
    },
    getUnixTime() {
      return Date.now();
    },
    loginSuccess(response) {
      this.$store.dispatch('setToken', response.data.token);
      this.$store.dispatch('setUser', response.data.user);

      this.$cookies.set('token', response.data.token, 0);
      this.$http.defaults.headers.common['Authorization'] =
        'Bearer ' + response.data.token;

      setTimeout(() => {
        this.$router.replace('/hero');
        this.loading = false;
      }, 500);
    },
    ssoLoginSuccess(email, loginToken) {
      this.$http
        .post('/api/auth/login/token', { email: email, loginToken: loginToken })
        .then((response) => {
          if (response.data.result === false) {
            this.$store.dispatch('setWebexLoginMode', false);
            this.$router.replace(`/403`);
            this.loading = false;
            return;
          }
          this.loginSuccess(response);
        })
        .catch((error) => {
          this.$store.dispatch('setWebexLoginMode', false);
          this.$router.replace(`/403`);
          this.loading = false;
          return;
        });
    },
  },
};
</script>
<style scoped>
.full-height {
  background: white;
  min-height: calc(100vh - 64px - 50px);
}
</style>



// WEBPACK FOOTER //
// src/pages/SSOSuccess.vue